/**
 * T-0403 criterion 5 — the reviewer-rejection ledger, over HTTP.
 *
 * Its own module rather than another entry in `BackendAPI`: `web/src/lib/api.ts`
 * sits at its grandfathered god-file ceiling of 1744 lines, so one more helper
 * there turns the ratchet red. `comparisonsApi.ts` and `traceApi.ts` set the
 * precedent for a small feature-shaped client beside it.
 */
import { api } from './api';

/** The five-tuple identifying a candidate, plus what the reviewer decided. */
export interface PropagationReview {
  rule: string;
  target_room: string;
  target_surface: string;
  cat: string;
  sel: string;
  decision: 'accepted' | 'rejected' | 'edited';
  reason?: string | null;
}

export const PropagationReviewsAPI = {
  /**
   * Records one reviewer decision about one propagation candidate.
   *
   * The record lands in the scope's own `metadata.propagation_reviews`
   * namespace, which a regenerate cannot erase (`app/services/scope_merge.py`).
   *
   * Args:
   *   projectId (string): The project owning the scope.
   *   scopeId (string): The stored scope the candidate appears on.
   *   review (PropagationReview): The tuple and the decision.
   *
   * Returns:
   *   Promise<object>: { key, decision, actor, at, count }.
   */
  record: (
    projectId: string,
    scopeId: string,
    review: PropagationReview,
  ): Promise<Record<string, unknown>> =>
    api.post(
      `/user/projects/${projectId}/scopes/${scopeId}/propagation-reviews`,
      review,
    ),
};
